import React from "react";
import TicketRouteType from "@MyTicket/types/TicketRoute.type";
import TicketNotifications from "@MyTicket/features/ticketDetails/components/TicketNotifications";
import Notification from "@Features/notification/components/Notification";
import Translation from "@Translation/components/Translation";

interface TicketDataProps {
    status: {
        isCancelled: boolean,
        isExchangedForVoucher: boolean,
        isExpired: boolean,
        isMTicket: boolean,
    }
    id: string,
    route: TicketRouteType,
    isArchived: boolean,
    hasReturn: boolean,
    isReturn?: boolean
}

function TicketData(props: TicketDataProps) {
    const {
        status,
        id,
        route,
        isArchived,
        isReturn,
        hasReturn,
    } = props

    return (
        <>
            {hasReturn && (
                <Notification
                    isBorder
                    notificationType="primary"
                    additionalClass="ticket-details__direction-notification"
                >
                    <Translation
                        translationKey={isReturn ? "sys.return" : "sys.outbound"}
                    />
                </Notification>
            )}
            <TicketNotifications
                status={status}
                routeType={route.transportTypeId}
            />
        </>
    );
}

export default TicketData;